module.exports = __webpack_public_path__ + "static/img/whistle.30207c5.png";